const CHUNK_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'importing a module script failed',
  'error loading dynamically imported module',
  'load failed',
  'is not a valid javascript mime type',
];

const RELOAD_KEY = 'vidi-chunk-reload-ts';
const RELOAD_COOLDOWN_MS = 10_000;

/** Detect whether an error is caused by a missing/stale JS chunk (e.g. after a deploy). */
export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const msg = error.message.toLowerCase();
  return CHUNK_ERROR_PATTERNS.some((p) => msg.includes(p));
}

/**
 * Auto-reload the page once to fetch fresh assets after a deploy.
 * Returns `true` if a reload was triggered, `false` if we already reloaded recently
 * (prevents infinite reload loops).
 */
export function handleChunkError(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || '0');
    if (Date.now() - last < RELOAD_COOLDOWN_MS) return false;

    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    window.location.reload();
    return true;
  } catch {
    // sessionStorage unavailable (private browsing edge case) — don't reload
    return false;
  }
}
